import * as React from 'react';
import { UserRequestContext } from 'aws-sdk/clients/awsdatalakegladstonelambda';
import { Container, Header, KeyValuePairs, TextContent } from '@amzn/awsui-components-react-v3';
import { linkForGroupOrWorkspace } from 'src/components/dataadvisory/constants';
import { Link } from 'src/components/common/Link';
import { createLFPermissionDetailLink, createRequestDetailsLink } from 'src/routes';

export interface RequestContextMetadataContainerProps {
  requestContext: UserRequestContext;
  workspaceNameMap?: Map<string, string>;
}

export const RequestContextMetadataContainer = (props: RequestContextMetadataContainerProps) => {
  const readableContextScope = () => {
    const contextScope = props.requestContext.contextScope;
    if (contextScope == 'AccessRequest') {
      return 'Access request';
    } else if (contextScope == 'AccessReview') {
      return 'Access review';
    } else {
      return contextScope;
    }
  };
  const readableType = () => {
    const type = props.requestContext.type;
    if (type == 'D3ADataUsageAgreement') {
      return 'Data usage agreement';
    } else {
      return type;
    }
  };
  return (
    <Container header={<Header variant={'h2'}>Details</Header>}>
      <KeyValuePairs
        columns={3}
        items={[
          { label: 'ID', value: props.requestContext.requestContextId },
          { label: 'Version ID', value: props.requestContext.requestContextId },
          { label: 'Context scope', value: readableContextScope() },
          { label: 'Owner ID', value: linkForGroupOrWorkspace(props.requestContext.ownerId, props.workspaceNameMap) },
          props.requestContext.accessRequestIds?.length > 0
            ? {
                label: "Request ID's",
                value: (
                  <TextContent>
                    <ul>
                      {props.requestContext.accessRequestIds?.map((requestId) => (
                        <li>
                          <Link href={createRequestDetailsLink(requestId)}>{requestId}</Link>
                        </li>
                      ))}
                    </ul>
                  </TextContent>
                ),
              }
            : undefined,
          props.requestContext.dataPermissionIds?.length > 0
            ? {
                label: "Data permission ID's",
                value: (
                  <TextContent>
                    <ul>
                      {props.requestContext.dataPermissionIds?.map((dataPermissionId) => (
                        <li>
                          <Link href={createLFPermissionDetailLink(dataPermissionId)}>{dataPermissionId}</Link>
                        </li>
                      ))}
                    </ul>
                  </TextContent>
                ),
              }
            : undefined,
          { label: 'Created by', value: props.requestContext.createdBy },
          { label: 'Created at', value: props.requestContext.createdAt },
          { label: 'Updated by', value: props.requestContext.updatedBy },
          { label: 'Updated at', value: props.requestContext.updatedAt },
          { label: 'Type', value: readableType() },
        ].filter((item) => item != undefined)}
      />
    </Container>
  );
};
